import reducer, { initialState } from '../../reducers/trustPicker';
import * as actions from '../../actions/trustPicker';

const fn = { reducer, initialState, actions };
export default fn;
 
